// extracted by mini-css-extract-plugin
export var addToCartButton = "_oy-b";
export var arrowButtonContainer = "_oy-9";
export var arrowButtonIcon = "_oy-a";
export var carouselArrowButton = "_oy-6";
export var carouselElementContainer = "_oy-1";
export var galleryThumbnail = "_oy-d";
export var galleryThumbnailImage = "_oy-e";
export var left = "_oy-7";
export var productDisplayCarouselContainer = "_oy-0";
export var productTileContainer = "_oy-2";
export var productTileImage = "_oy-4";
export var productTileImageContainer = "_oy-3";
export var productTileTitle = "_oy-5";
export var right = "_oy-8";
export var sliderOverflow = "_oy-c";